export default __webpack_public_path__ + "static/media/social-instagram.8241b985.svg";